import React from "react";
import ProjectCaseStudyTemplate from "./ProjectCaseStudyTemplate.tsx";
import tokyoAfterfallData from "./tokyoAfterfallData.tsx";

function TokyoAfterfallPage() {
    return <ProjectCaseStudyTemplate data={tokyoAfterfallData} />;
}

export default TokyoAfterfallPage;
